const Home = () => <div />;

export default Home;
